import serviceTypeCodes from 'constants/serviceTypeCodes';
import serviceTypeBrandcodes from 'constants/serviceTypeBrandcodes';
import { bookingStatusTypes } from 'types/booking';

const getResarailLabel = ({ brandCode }) => {
  const labels = {
    [serviceTypeBrandcodes.SNCF]: 'SNCF PNR',
    [serviceTypeBrandcodes.INOUI]: 'SNCF PNR',
    [serviceTypeBrandcodes.Lyria]: 'LYRIA PNR'
  };

  return labels[brandCode] || 'ResaRail';
};

const getResarailJourneyInfos = (journey) =>
  journey
    .filter(({ serviceType }) => serviceType.code === serviceTypeCodes.SNCF)
    .flatMap((item) => {
      const {
        bookingItems,
        origin,
        destination,
        serviceType: { brandCode }
      } = item;
      const confirmedItems = bookingItems?.filter((item) => item.status === bookingStatusTypes.CONFIRMED);
      const confirmedItemsAdditionalDetails = confirmedItems?.flatMap((item) => item.additionalDetails);

      return Array.from(
        new Set(
          confirmedItemsAdditionalDetails
            ?.filter((additionals) => additionals.key === 'RESARAIL_PNR')
            ?.map((detail) =>
              JSON.stringify({
                key: detail.key,
                name: getResarailLabel({ brandCode }),
                PNR: detail.value,
                origin: origin.name,
                destination: destination.name
              })
            )
        )
      ).map((string) => JSON.parse(string));
    });

const getResarailBookingInfos = ({ booking }) => {
  const { outbound, inbound } = booking;

  const outboundResarailInfos = getResarailJourneyInfos(outbound);

  const inboundResarailIinfos = getResarailJourneyInfos(inbound);

  return [...outboundResarailInfos, ...inboundResarailIinfos];
};

export { getResarailBookingInfos, getResarailJourneyInfos, getResarailLabel };
